import React from "react";
import { motion } from "framer-motion";
import { NOTICIAS } from "../../data";

const fmt = (d) =>
  new Date(d).toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" });

export default function Noticias() {
  return (
    <section id="noticias" className="py-20 lg:py-28 bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-espana-red mb-3">
          Actividad viva
        </p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight leading-tight">
          Noticias y Actividad
        </h2>

        <div className="mt-12 relative border-l-2 border-gray-200 ml-2">
          {NOTICIAS.map((n, i) => (
            <motion.div
              key={n.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              data-testid={`noticia-${i}`}
              className="relative pl-8 pb-10 last:pb-0"
            >
              <span className="absolute -left-[9px] top-1.5 h-4 w-4 rounded-full bg-espana-red border-4 border-white" />
              <div className="flex items-center gap-3 mb-1">
                <span className="text-xs font-bold uppercase tracking-widest text-espana-gold bg-espana-red px-2 py-0.5">
                  {n.tag}
                </span>
                <span className="text-sm text-gray-400">{fmt(n.date)}</span>
              </div>
              <h3 className="text-xl font-bold">{n.title}</h3>
              <p className="mt-1 text-gray-600 leading-relaxed max-w-2xl">{n.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
